module.exports = __webpack_public_path__ + "static/img/orderBatch-demo-02.78a66dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/orderBatch-demo-02.jpg
// module id = UPdh
// module chunks = 9